import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { setIsLoading } from "store";
import {
  getExcepcionesInactividad,
  getPeriodoInactividadService,
} from "services/periodosinactividad/periodosinactividadService";
import {
  onLoadCanExecute,
  onLoadPeriodosInactividad,
} from "store/periodosInactividad/periodosInactividadSlice";//eslint-disable-next-line
import Swal from "sweetalert2";
import { useAuthStore } from "hooks/useAuthStore";

export const usePeriodosInactividad = () => {
  const dispatch = useDispatch();
  const { dataPeriodosInactividad, canExceute } = useSelector(
    (state: RootState) => state.periodosInactividadSlice
  );
  const { user } = useAuthStore();

  const startGetPeriodosInactividad = async (
    cveTipoActividad: number,
    pEvaluate?: boolean
  ) => {
    getPeriodoInactividadService()
      .then(({ data }) => {
        dispatch(setIsLoading(false));
        if (data?.data !== null) {
          startGetExcepcionesInactividad(
            data.data.descInactividad,
            data?.data?.idPeriodoInactividad,
            cveTipoActividad,
            pEvaluate
          );
          dispatch(onLoadPeriodosInactividad(data.data));
          dispatch(setIsLoading(false));
        }
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        console.log(err);
      });
  };

  const startGetExcepcionesInactividad = async (
    message: string,
    id: number,
    cveTipoActividad: number,
    pEvaluate?: boolean
  ) => {
    getExcepcionesInactividad({
      idPeriodoInactividad: id,
      cveTipoActividad: cveTipoActividad,
      cveTipoAbogado: Number(user?.CveTipoAbogado),
      cveUsuario: user?.session?.cveUsuario,
    })
      .then(({ data }) => {
        if (!data?.data) {
          // Swal.fire({
          //   title: "Periodo de inactividad",
          //   html: `
          //     <style>
          //       .swal2-container {
          //         z-index: 99999
          //       }
          //     </style>
          //     <p>${message}</p>`,
          //   icon: "warning",
          //   confirmButtonText: "Aceptar",
          // });
        } else {
          dispatch(onLoadPeriodosInactividad(null));
          if (pEvaluate) {
            dispatch(onLoadCanExecute(true));
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const resetCanExecute = () => {
    dispatch(onLoadCanExecute(false));
  };
  return {
    // Propiedades
    dataPeriodosInactividad,
    canExceute,
    // Metodos
    startGetPeriodosInactividad,
    startGetExcepcionesInactividad,
    resetCanExecute,
  };
};
